import axios from 'axios';

import { get } from './index';

export function getCountryList() {
  return get<Country[]>('/doniaLiveCountry/info/list');
}

export function getAppConfig(language: string = 'en') {
  return get<Locale>('/doniaLiveClient/configure', { language });
}

export function getLocales(url: string): Promise<string> {
  return axios.get<string>(url).then((res) => res.data);
}
